import { useCallback } from "react"

import { usePersistedOutfitter } from "~utils/hooks/use-persisted-selected-global-outfitter"
import { usePersistedEventOrganizer } from "~utils/hooks/use-persisted-event-organizer"
import { usePersistedPortalType } from "~utils/hooks/use-persisted-portal-type"

export function usePersistedPortalEntities() {
    const { outfitter, setOutfitter } = usePersistedOutfitter()
    const { eventOrganizer, setEventOrganizer } = usePersistedEventOrganizer()
    const { portalType, setPortalType } = usePersistedPortalType()

    const clearAllPersistedPortalEntities = useCallback(() => {
        setOutfitter(null)
        setEventOrganizer(null)
        setPortalType(null)
    }, [])

    return {
        outfitter,
        setOutfitter,
        eventOrganizer,
        setEventOrganizer,
        portalType,
        setPortalType,
        clearAllPersistedPortalEntities,
    }
}
